import { CONST } from 'tsRoot/constants';
import Cookies from 'js-cookie'

setThanksPageLink();

// 0.8秒後にリダイレクトする
setTimeout(redirect, 800);

// リダイレクト処理
function redirect() {
    // リダイレクトを実行
    location.href = get_thanks_target_url();
}

// サンクスページリンクを設定
function setThanksPageLink() {
    var thanksPageLink = document.getElementById('thanks_link');
    if(thanksPageLink) {
        thanksPageLink.setAttribute('href',get_thanks_target_url());
    }
}

function get_thanks_target_url(): string {

    // URLパラメータを取得
    var q = new URLSearchParams(location.search)
    var extToken = q.get("ext")
    var projectId = q.get("project_id") || Cookies.get('project_id')
    var startedAt = q.get("started_at") || Cookies.get('started_at')
    var from = q.get("from")

    // リダイレクト先URLを生成、デフォルトはトップページ
    var target_url = Cookies.get('target_url')
    if(extToken) {
        // 独自のリダイレクト先が設定されていない場合はデフォルトの会員登録URLへ遷移
        if (!target_url) {
            target_url = `${CONST.API.MY_PAGE_HOST}/users/interview_external`;
        }
        // 拡張トークンをパラメータに追加
        target_url += `?ext=${extToken}`;
        // プロジェクトIDがある場合はパラメータに追加
        if (projectId) {
            target_url += `&project_id=${projectId}`;
        }
        // 特殊パラメータによる画面遷移
        // 開始日時がある場合はパラメータに追加
        if(startedAt) {
            target_url += `&started_at=${startedAt}`;
            target_url = target_url.replace("/users/interview_external", "/landing/regist");
        }
        else if (from == "line") {
            target_url = target_url.replace("/users/interview_external", "/users/line_interview_external");
        }
    } else {
        target_url = "/";
    }

    return target_url
}